import {formatDateUrl} from "@lib/format";

interface AcfLink {
    target: string;
    title: string;
    url: string;
}

interface AcfImage {
    src: string;
}

interface WordPressPageContent {
    builder_fc: {
        acf_fc_layout: string;
        structure_fc: {
            acf_fc_layout: string;
            blocks_fc: {
                acf_fc_layout: string;
                carousel_re: {
                    title: string;
                    image: { url: string };
                    link: AcfLink
                }[];
            }[];
        }[];
    }[];

    layout_builder: {
        blocks: {
            blockName: string;
            results: any[];
            html?: string;
            attrs: {
                title: string;
                date?: string;
                items: {
                    ID: string;
                    title: string;
                    description: string;
                    link: AcfLink;
                    image: AcfImage;
                    isPremium: boolean;
                }[];
            };
        }[];
    };
}

interface CovrSlide {
    title: string;
    subtitle: string;
    link_text: string;
    link_url: string;
    image: string;
}

interface CovrList {
    title: string;
    subtitle: string;
    link_url: string;
    image: string;
    premium: boolean;
}

interface CovrContent{
    taxons: {
        title: string;
        color: string;
        link_url: string;
        image: string;
    }[];

    posts: {
        title: string;
        description: string;
        date: Date;
        link_url: string;
        image: string;
    }[];

    videos: any;
    articles: any;
}

interface HomePageContentResults {
    slides: CovrSlide[];
    listItems: CovrList[];
    cpContent: CovrContent;
    hasResults: boolean;
    weeklyTopTenDate: string;
    images: {
        modal_bg_url: string;
    };
}

export const transformHomePageContent = (data: WordPressPageContent, isLoggedIn: boolean): HomePageContentResults | null => {
    const acfBlocks = data.layout_builder && data.layout_builder.blocks;
    const customCollections = acfBlocks && acfBlocks.filter(block => block.blockName === 'acf/custom-collection');
    const images = acfBlocks && acfBlocks.filter(block => block.blockName === 'core/image');
    const weeklyTopTen = acfBlocks && acfBlocks.filter(block => block.blockName === 'acf/weekly-top-ten-carousel');

    const result :HomePageContentResults = {
        slides: [],
        listItems: [],
        cpContent: {
            taxons: [],
            posts: [],
            videos: null,
            articles: null,
        },
        weeklyTopTenDate: formatDateUrl(new Date()),
        hasResults: false,
        images: {
            modal_bg_url: '',
        },
    };

    if(weeklyTopTen.length > 0 && weeklyTopTen[0].attrs.date){
        result.weeklyTopTenDate = weeklyTopTen[0].attrs.date;
    }

    if(images){
        const modal_bg = images[0];
        const matches = modal_bg && modal_bg.html ? modal_bg.html.match(/src="([^"]*)/g) : null;
        result.images.modal_bg_url = matches ? matches[0].slice(5) : '';
    }

    if(customCollections){
        const carousel = customCollections.find(collection => collection.attrs.title == (isLoggedIn ? 'carousel-logged-in' : 'carousel-logged-out'));

        result.slides = carousel ? carousel.attrs.items.map(slide => ({
            title: slide.title,
            subtitle: slide.description,
            image: slide.image.src,
            link_text: slide.link.title,
            link_url: slide.link.url,
        })) : [];

        const covrLists = customCollections.find(collection => collection.attrs.title == 'cp-lists');

        result.listItems = covrLists ? covrLists.attrs.items.map(listItem => ({
            title: listItem.title,
            subtitle: listItem.description,
            link_url: listItem.link.url,
            image: listItem.image.src,
            premium: listItem.isPremium,
        })) : [];

        result.hasResults = true;
    }

    if(acfBlocks){
        const cpTaxons = acfBlocks && acfBlocks.filter(block => block.blockName === 'acf/taxonomy-collection');
        const cpPosts = acfBlocks && acfBlocks.filter(block => block.blockName === 'acf/post-collection');
        const cpYouTube = acfBlocks && acfBlocks.filter(block => block.blockName === 'acf/youtube-search');

        if(cpTaxons && cpTaxons.length > 0) {
            result.cpContent.taxons = cpTaxons[0].results.map(result => ({
                title: result.name,
                color: result.color,
                link_url: result.link.url,
                image: result.image.src,
            }));
        }

        if(cpPosts && cpPosts.length > 0) {
            result.cpContent.posts = cpPosts[0].results.map(result => ({
                title: result.title,
                description: result.description,
                date: new Date(result.date),
                link_url: result.link.url,
                image: result.image.src,
            }));

            result.cpContent.articles = cpPosts[0];
        }

        if(cpYouTube && cpYouTube.length > 0) {
            const videos = {...cpYouTube[0], attrs: {...cpYouTube[0].attrs, title: 'COVRPRICE'}}
            result.cpContent.videos = videos;
        }
    }

    return result.hasResults ? result : null;
}

interface CovrShopLink {
    slug: string;
    subtitle: string;
    link_url: string;
    image: string;
    active: boolean;
}

interface DescriptorListContentResults {
    shopLinks: CovrShopLink[];
    hasResults: boolean;
}

export const transformDescriptorListContent = (data: WordPressPageContent): DescriptorListContentResults | null => {
    const acfBlocks = data.layout_builder && data.layout_builder.blocks;
    const customCollections = acfBlocks && acfBlocks.filter(block => block.blockName === 'acf/custom-collection');

    const result :DescriptorListContentResults = {
        shopLinks: [],
        hasResults: false,
    };

    if(customCollections){
        const shopLinks = customCollections.find(collection => collection.attrs.title == 'shop-link');

        result.shopLinks = shopLinks ? shopLinks.attrs.items.map(listItem => ({
            slug: listItem.title,
            subtitle: listItem.description,
            link_url: listItem.link.url,
            image: listItem.image.src,
            active: listItem.isPremium,
        })) : [];

        result.hasResults = true;
    }


    return result.hasResults ? result : null;
}